export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
};

export enum STRIPE_TYPES {
  PRODUCT = 'PRODUCT',
  ADDON = 'ADDON',
};
